import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
    {
        id: 1,
        label: 'Tableau de bord',
        icon: 'ri-dashboard-line',
        link: '/suivi/tableaux-de-bord',
        roles: ['admin', 'point_focal'],// Seuls 'admin'point_focal
        rolesDirection: [''],

    },

    {
        id: 5,
        label: 'Plan Analytique',
        icon: 'ri-store-2-line',
        roles: ['admin'],
        rolesDirection: [''],
        subItems: [
            // ----- Cadre logique -----
            {
                id: 51,
                label: 'Cadre logique',
                parentId: 5,
                subItems: [
                    { id: 511, label: 'Programmes', link: '/suivi/plan/programmes' },
                    { id: 512, label: 'Objectifs Spécifiques', link: '/suivi/plan/objectif-specifique' },
                    { id: 513, label: 'Résultats', link: '/suivi/plan/resultat' },
                    { id: 514, label: 'Actions/Projets', link: '/suivi/plan/action' }
                ]
            },

            // ----- Indicateurs -----
            {
                id: 52,
                label: 'Indicateurs',
                parentId: 5,
                subItems: [
                    { id: 521, label: 'Indicateurs de performance', link: '/suivi/plan/indicateur-performance' },
                    { id: 522, label: 'Indicateurs de résultats', link: '/suivi/plan/indicateur-resultat' },
                    { id: 523, label: 'Indicateurs d’objectifs', link: '/suivi/plan/indicateur-objectif' }
                ]
            },

            // ----- Directions -----
            {
                id: 53,
                label: 'Directions',
                link: '/suivi/plan/direction',
                parentId: 5
            },

            // ----- Services -----
            {
                id: 54,
                label: 'Services',
                link: '/suivi/plan/service',
                parentId: 5
            },

            // ----- Projets PDC Accueil -----
            {
                id: 55,
                label: 'Projets PDC Accueil',
                link: '/suivi/plan/projets-pdc',
                parentId: 5
            }
        ]
    }
    ,

    {
        id: 6,
        label: 'PDC',
        icon: 'ri-bookmark-2-fill',
        roles: ['admin'], // Seuls 'admin'
        rolesDirection: [''],

        subItems: [
            {
                id: 8,
                label: 'Importation & Edition',
                link: '/pdc/importation',
                parentId: 6

            },
            // {
            //     id: 9,
            //     label: 'Edition du pdc',
            //     link: '/pdc/edition-pdc',
            //     parentId: 6
            // },
            {
                id: 10,
                label: 'Consultation PDC',
                link: '/pdc/consultation-pdc',
                parentId: 6
            },

            {
                id: 10,
                label: 'Consultation par année',
                link: '/pdc/consultation-par-annee',
                parentId: 6
            },

            // {
            //     id: 10,
            //     label: 'Evaluation du pdc ',
            //     link: '/pdc/evaluation-pdc',
            //     parentId: 6
            // },
        ]
    },
    {
        id: 13,
        label: 'Planification',
        icon: 'ri-mail-send-line',
        roles: ['admin'], // Seul 'admin' peut voir cet élément
        rolesDirection: [''],
        subItems: [
            {
                id: 14,
                label: 'Importation PTA',
                link: '/suivi/planification/importation',
                parentId: 14
            },
            {
                id: 15,
                label: 'Mise en conformité PTA',
                link: '/suivi/planification/validation',
                parentId: 14
            },

            {
                id: 20,
                label: 'Pta par période',
                link: '/suivi/planification/pta-par-periode',
                parentId: 14
            },

            {
                id: 16,
                label: 'Revue budgétaire',
                link: '/suivi/planification/budgetaire',
                parentId: 14
            }

            ,
            {
                id: 17,
                label: 'Cibles des Indicateurs',
                link: '/suivi/planification/cible-indicateurs',
                parentId: 14
            },
            // {
            //     id: 18,
            //     label: 'Mission',
            //     link: '/suivi/planification/mission',
            //     parentId: 14
            // },
            {
                id: 19,
                label: 'Recommandation',
                link: '/suivi/planification/recommandation',
                parentId: 14
            },

            // ,
            // {
            //     id: 18,
            //     label: 'Activités hors PTA',
            //     link: '/suivi/planification/activite-hors-pta',
            //     parentId: 14
            // }
        ]
    },

    {
        id: 23,
        label: 'Exécution',
        icon: 'ri-profile-line',
        roles: ['admin'],
        rolesDirection: ['DAAF'],
        subItems: [
            {
                id: 24,
                label: 'Exécution Tâches',
                link: '/suivi/execution/tâche',
                parentId: 23,

            },
            {
                id: 26,
                label: 'Réalisations Indicateurs',
                link: '/suivi/execution/realisation',
                parentId: 23
            },
            {
                id: 27,
                label: 'Engagements',
                link: '/suivi/execution/engagement',
                parentId: 23,
                rolesDirection: ['DAAF'], // Seul 'DAAF' ne peut voir ce sous-menu

            },
            {
                id: 28,
                label: 'Ordonnancements',
                link: '/suivi/execution/ordonnancement',
                parentId: 23,
                rolesDirection: ['DAAF'], // Seul  ne peut 'DAAF' peut voir ce sous-menu

            },
            {
                id: 29,
                label: 'Décaissements',
                link: '/suivi/execution/decaissemnt',
                parentId: 23,
                rolesDirection: ['DAAF'], // Seul  ne peut 'DAAF' peut voir ce sous-menu

            },

            {
                id: 30,
                label: 'Activités hors PTA',
                link: '/suivi/execution/activite-hors-pta',
                parentId: 23,
                rolesDirection: ['DAAF'], // Seul  ne peut 'DAAF' peut voir ce sous-menu

            },

            {
                id: 31,
                label: 'Recommandation',
                link: '/suivi/execution/recommandation',
                parentId: 23,
                rolesDirection: ['DAAF'], // Seul  ne peut 'DAAF' peut voir ce sous-menu

            },
            //  {
            //     id: 24,
            //     label: 'Traitement recommandation',
            //     link: '/suivi/execution/traitement-recommandation',
            //     parentId: 14
            // }
        ]
    },

    {
        id: 60,
        label: 'Bordereau de recettes',
        icon: 'ri-file-list-3-line',
        roles: ['admin'],
        rolesDirection: ['DAAF'],
        subItems: [
            {
                id: 601,
                label: 'Chapitre budgétaire',
                parentId: 60,
                subItems: [
                    { id: 6011, label: 'Chapitre', link: '/suivi/recettes/bordereau-recettes/chapitre' },
                    { id: 6012, label: 'Sous-chapitre', link: '/suivi/recettes/bordereau-recettes/sous-chapitre' },
                    { id: 6013, label: 'Compte budgétaire', link: '/suivi/recettes/bordereau-recettes/compte-budgetaire' }
                ]
            },
            {
                id: 602,
                label: 'Prévision budgétaire',
                link: '/suivi/recettes/bordereau-recettes/prevision',
                parentId: 60
            },
            {
                id: 603,
                label: 'Titre des recettes nettes',
                link: '/suivi/recettes/bordereau-recettes/titres',
                parentId: 60
            },
            {
                id: 604,
                label: 'Recouvrement',
                link: '/suivi/recettes/bordereau-recettes/recouvrement',
                parentId: 60
            }
        ]
    },

    {
        id: 23,
        label: 'Edition',
        icon: 'ri-edit-fill',
        rolesDirection: ['DAAF'],

        subItems: [

            //  { id: 39, label: 'Budget / Programme', link: '/suivi/edition/budget-by-programme' },
            // -----------------------
            // GROUPE 1 : PROGRAMME
            // -----------------------
            {
                id: 230,
                label: 'Taux Exécution Physique',
                parentId: 23,
                subItems: [

                    { id: 37, label: 'Graphe / Programme', link: '/suivi/edition/graphique' },
                    { id: 27, label: 'TEP / Programme', link: '/suivi/edition/tep-projet' },
                    { id: 34, label: 'TEP / Projets', link: '/suivi/edition/tep-by-projet' },
                    {
                        id: 25,
                        label: 'TEP / Direction',
                        link: '/suivi/edition/tep-direction',
                        parentId: 23
                    },
                    // -----------------------
                    // GROUPE 2 : DIRECTIONS & SERVICES (non groupés)
                    // -----------------------
                    {
                        id: 41,
                        label: 'TEP / Service',
                        link: '/suivi/edition/pta-service',
                        parentId: 23
                    },
                    //{ id: 32, label: 'TEF / Programme', link: '/suivi/edition/bilan' }
                ]
            },




            // -----------------------
            // GROUPE 3 : BILAN PHYSIQUE & FINANCIER
            // -----------------------
            {
                id: 232,
                label: 'Bilan physique et financier',
                parentId: 23,
                subItems: [
                    { id: 44, label: 'Évaluation du PTA', link: '/suivi/edition/evaluation-pta' },
                    { id: 43, label: 'Évaluation du PAI', link: '/suivi/edition/tep-pai' },
                    { id: 42, label: 'Évaluation du PDC', link: '/suivi/edition/pdc' },
                    // { id: 40, label: 'Fiche évaluation du SE', link: '/suivi/edition/pta-global' }
                ]
            },

            // -----------------------
            // INDICATEURS (SEULS)
            // -----------------------
            {
                id: 31,
                label: 'Tableau des Indicateurs',
                link: '/suivi/edition/tableaubord-indicateur',
                parentId: 23
            },
            // {
            //     id: 38,
            //     label: 'Tableau Indicateur ODD',
            //     link: '/suivi/edition/indicateur-cle',
            //     parentId: 23
            // }
        ]
    }
    ,



    {
        id: 10,
        label: 'Parametrage',
        icon: 'ri-settings-line',
        rolesDirection: [''],
        roles: ['admin'],

        subItems: [

            {
                id: 1,
                label: 'Param. Global',
                link: '/parametrage/generale',
                parentId: 10

            },
            {
                id: 2,
                label: 'Param. Mot du maire',
                link: '/parametrage/maire',
                parentId: 10
            },
            {
                id: 2,
                label: 'Param. PTA / PDC',
                link: '/parametrage/pta-pdc',
                parentId: 10
            },
            {
                id: 1,
                label: 'Param. Images défilantes ',
                link: '/parametrage/slide',
                parentId: 10

            },

            {
                id: 1,
                label: 'Param. Poids.Pdc.Année ',
                link: '/parametrage/poids-pdc',
                parentId: 10

            },
            {
                id: 6,
                label: 'Gestion Utilisateurs',
                link: '/suivi/plan/gestion-acces',
                parentId: 10
            },

        ]
    },
];


export const MENURECHERCHE: MenuItem[] = [
    // {
    //     id: 1,
    //     label: 'TABLEAU DE BORD',
    //     icon: 'ri-dashboard-line',
    //     link: '/recherche/tableaux-de-bord',
    //     rolesDirection: [''],

    // },
    // {
    //     id: 5,
    //     label: 'Ressources',
    //     icon: 'ri-store-2-line',
    //     link: '/recherche/ressource',
    //     rolesDirection: [''],


    // },
    // {
    //     id: 5,
    //     label: "Sites d'essais pilotes",
    //     icon: 'ri-bubble-chart-line',
    //     link: '/recherche/centre',
    //     rolesDirection: [''],


    // },
    // {
    //     id: 5,
    //     label: 'Acteurs',
    //     icon: ' ri-shield-user-line',
    //     link: '/recherche/acteurs',
    //     rolesDirection: [''],

    // },

    // {
    //     id: 1,
    //     label: 'DECONNEXION',
    //     icon: 'ri-government-line',
    //     link: '/service',
    //     rolesDirection: [''],

    // },
];
